module.exports = __webpack_public_path__ + "static/media/Experience - Hexagon.82217e27.png";